import { Layout } from 'antd';
import React from 'react';

const ApplicationFooter = () => (
  <Layout>
    <Layout.Footer style={{ textAlign: 'center' }}>
      КФКПН - Support bot ©{new Date().getFullYear()}
    </Layout.Footer>
  </Layout>
);

export default ApplicationFooter;
